// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-transfer-ownership-user-select .mat-mdc-form-field {
  width: 100%;
}
.fi-transfer-ownership-user-select .mat-mdc-form-field .mat-select-trigger-content {
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/other-settings/transfer-ownership/fi-transfer-ownership-user-select/fi-transfer-ownership-user-select.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AACQ;EACI,kBAAA;AACZ","sourcesContent":[".fi-transfer-ownership-user-select {\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n        .mat-select-trigger-content {\r\n            padding-left: 10px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
